// extracted by mini-css-extract-plugin
module.exports = {"box":"box--c-nvr","list":"list--iXgbL"};